import React from "react";
import { Link } from "react-router-dom";
import LogoMain from "../images/main-logo.png";

export default function Comparatif() {
    return(
    <section className="mx-auto max-w-[1219px] px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="rounded-3xl bg-white">
          <div className="px-5 sm:px-8 pt-8">
            <h2 className="text-2xl sm:text-3xl font-asap font-semibold text-neutral-900 text-center">
              Comparez clairement
            </h2>
            <p className="mt-2 text-[15px] text-neutral-700 text-center">
              Les critères essentiels pour votre commerce, ligne par ligne.
            </p>
          </div>

          {(() => {
            const ROWS = [
              { label: "Visibilité locale", sans: false, avec: true },
              { label: "Cartes de fidélité dématérialisées",    sans: false, avec: true },
              { label: "Publication d’offres en quelques secondes", sans: false, avec: true },
              { label: "Lien à tous moments avec votre clientelles", sans: false, avec: true },
            ];

            return (
              <>
                {/* TABLET & DESKTOP */}
                <div className="hidden sm:block rounded-3xl overflow-hidden mt-8 ring-1 ring-black/10 shadow-[0_10px_30px_rgba(0,0,0,0.08)]">
                  <div className="overflow-x-auto">
                    <table className="w-full min-w-[820px] border-collapse">
                      <thead className="text-sm text-neutral-600">
                        <tr className="border-b border-black/10">
                          <th className="text-left font-semibold px-6 py-4 w-[46%]">Critères</th>
                          <th className="text-center font-semibold px-6 py-4 w-[27%]">Sans application</th>
                          <th className="text-center font-semibold px-6 py-4 w-[27%]">
                            <div className="inline-flex items-center justify-center gap-2">
                              <img src={LogoMain} alt="PACTE" className="h-6 w-auto" />
                              <span>Avec l’application PACTE</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="text-[15px]">
                        {ROWS.map((row, i) => (
                          <tr key={row.label} className={i % 2 ? "bg-[#F6F6F7]" : "bg-white"}>
                            <td className="px-6 py-5 text-neutral-900">{row.label}</td>
                            <td className="px-6 py-5 text-center">
                              {typeof row.sans === "boolean" ? (
                                row.sans ? <Check /> : <Cross />
                              ) : (
                                <span className="text-neutral-700">{row.sans}</span>
                              )}
                            </td>
                            <td className="px-6 py-5 text-center">
                              {typeof row.avec === "boolean" ? (
                                row.avec ? <Check /> : <Cross />
                              ) : (
                                <span className="font-medium text-neutral-900">{row.avec}</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>


                <div className="sm:hidden mt-8 space-y-3">
                  {ROWS.map((row, i) => (
                    <div
                      key={row.label}
                      className="rounded-2xl border border-black/10 bg-white shadow-[0_6px_18px_rgba(0,0,0,0.06)] p-4"
                    >
                      <div className="text-[15px] font-medium text-neutral-900">{row.label}</div>

                      <div className="mt-3 grid grid-cols-1 gap-2">
                        <div className="flex items-center justify-between rounded-xl bg-[#F6F6F7] px-3 py-2">
                          <span className="text-[13px] text-neutral-600">Sans application</span>
                          <span>
                            {typeof row.sans === "boolean" ? (
                              row.sans ? <Check /> : <Cross />
                            ) : (
                              <span className="text-[13px] text-neutral-700">{row.sans}</span>
                            )}
                          </span>
                        </div>
                        <div className="flex items-center justify-between rounded-xl bg-[#F6F6F7] px-3 py-2">
                          <span className="text-[13px] text-neutral-600 inline-flex items-center gap-2">
                            <img src={LogoMain} alt="PACTE" className="h-4 w-auto" />
                            Avec l’app PACTE
                          </span>
                          <span>
                            {typeof row.avec === "boolean" ? (
                              row.avec ? <Check /> : <Cross />
                            ) : (
                              <span className="text-[13px] font-medium text-neutral-900">{row.avec}</span>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            );
          })()}


          <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/contact?type=partenaire#form"
              className="inline-flex items-center justify-center rounded-full bg-black text-white
                        px-6 py-3 text-sm font-medium shadow-[0_10px_24px_rgba(0,0,0,0.35)]
                        hover:opacity-90 transition"
            >
              Devenir partenaire
            </Link>
          </div>
        </div>
      </section>
    )
}

function Check() {
  return (
    <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-emerald-50 ring-1 ring-emerald-200">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="text-emerald-600">
        <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z" />
      </svg>
    </span>
  );
}

function Cross() {
  return (
    <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-rose-50 ring-1 ring-rose-200">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="text-rose-600">
        <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.41L12 13.41l-6.29 6.29-1.41-1.41L10.59 12 4.29 5.71 5.7 4.3 12 10.59 18.29 4.3z" />
      </svg>
    </span>
  );
}